import axios from "axios";

// Production uses the Cloudflare same-origin API proxy. Local CRA development
// can target FastAPI directly through REACT_APP_BACKEND_URL.
const backendOrigin = (process.env.REACT_APP_BACKEND_URL || (
  process.env.NODE_ENV === "development" ? "http://localhost:8000" : ""
)).replace(/\/$/, "");
export const API = `${backendOrigin}/api/web`;

const TOKEN_KEY = "dvmart_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const authHeaders = () => ({ Authorization: `Bearer ${getToken()}` });

export const fileUrl = (path) => `${API}/files/${path}`;

export const api = axios.create({ baseURL: API });
